// Definição para o modal de busca de NCMs
// Utilizada no cadastro de Produtos para seleção de NCM

export const criarConfigBuscaNcm = () => ({
  label: 'NCM',
  placeholder: 'Código NCM ou Descrição...',
  titulo: 'Pesquisar NCM',
  endpointApi: 'Ncms',
  endpointFetchPorCodigo: 'Ncms/por-codigo',
  idField: 'idNcm',
  displayField: 'codigoNcm',
  descField: 'descricao',
  tabela: 'Ncm',
  camposFiltro: [
    { model: 'busca', label: 'Código NCM ou Descrição', tipo: 'text' },
    { model: 'somenteAtivas', label: 'Apenas Ativas', tipo: 'hidden', value: true }
  ],
  colunasGrid: [
    { header: 'Código', dataField: 'codigoNcm', width: '15%' },
    { header: 'Descrição', dataField: 'descricao', width: '65%' },
    { header: 'Un. Estatística', dataField: 'lstUnidadeEstatistica', width: '20%' }
  ]
})
